export class Empresa {
    id: number;
    token_motor: string;
    bairro: string;
    cep: string;
    cidade: string;
    logo: string;
    nome_fantasia: string;
    about_empresa: string;
    endereco: string;
    telefone: string;
    celular: string;
}
